import {
  CENTS_IN_DOLLAR,
  INITIAL_PRICE,
} from '~/shared/constants/commonConstants'

export const getFormattedPrice = (price: number | undefined): number =>
  price ? price / CENTS_IN_DOLLAR : INITIAL_PRICE
